import { computed, type ComputedRef } from 'vue';
import type { ElementProperties } from './form.types';

const INPUT_BASE_CLASSES =
  'px-1.5 py-1 border border-[var(--color-gray-02)] rounded-md text-[var(--color-gray-07)] bg-white-01 focus:outline-none focus:border-[var(--theme-secondary-ink)] transition-colors';

export function useLabelPosition(properties: ComputedRef<ElementProperties> | ElementProperties) {
  const props = computed(() => {
    if (properties && typeof properties === 'object' && 'value' in properties) {
      return (properties as ComputedRef<ElementProperties>).value;
    }
    return properties as ElementProperties;
  });

  const isLabelLeft = computed(() => props.value.labelPosition === 'left');

  const inputClasses = computed(() => {
    return isLabelLeft.value ? INPUT_BASE_CLASSES : `w-full ${INPUT_BASE_CLASSES}`;
  });

  const labelClasses = computed(() =>
    isLabelLeft.value ? 'text-[10px] font-bold mr-1.5' : 'block text-[10px] font-bold mb-0.5'
  );

  const labelStyles = computed(() => {
    const p = props.value;
    const styles: Record<string, string> = {};
    if (p.fontSize) styles.fontSize = `${p.fontSize}px`;
    if (p.fontWeight === 'bold') styles.fontWeight = '700';
    else if (p.fontWeight === 'semibold') styles.fontWeight = '600';
    else if (p.fontWeight === 'normal') styles.fontWeight = '400';
    if (p.fontStyle === 'italic') styles.fontStyle = 'italic';
    if (p.textDecoration && p.textDecoration !== 'none') {
      styles.textDecoration = p.textDecoration;
      styles.textDecorationSkipInk = 'none';
    }
    if (p.textAlign) styles.textAlign = p.textAlign;
    if (p.color) styles.color = p.color;
    return styles;
  });

  return {
    isLabelLeft,
    inputClasses,
    labelClasses,
    labelStyles,
  };
}
